import React, { Component } from "react";
import displayCSS from "./display.module.scss";
import NumberBox from "../number-box/numberBox";

class Display extends Component {
  render() {
    const num = [];
    const n = 100;
    for (let i = 1; i <= n; i++) {
      if (i % 7 === 0 || i % 11 === 0) {
        num.push(
          <NumberBox key={i} number="buzz" cssStyle={displayCSS.BuzzHover} />
        );
      } else if (i.toString().split("").pop() === "7") {
        num.push(
          <NumberBox key={i} number="buzz" cssStyle={displayCSS.BuzzHover} />
        );
      } else {
        num.push(<NumberBox key={i} number={i} />);
      }
    }

    return <div className={displayCSS.Grid}> {num} </div>;
  }
}

export default Display;
